import React from "react";
import { string } from "prop-types";

import ProfileMenuItem from "../ProfileMenuItem";

import "./profile-menu-mobile.m.css";

const ProfileMenuMobile = ({ type = "profile" }) => (
  <div className="profile-mobile-menu">
    <div styleName="wrapper">
      <ProfileMenuItem label="My Profile" isActive={type === "profile"} href="/profile" />
      <ProfileMenuItem label="My Comments" isActive={type === "comments"} href="/my-comments" />
      <ProfileMenuItem label="My Saved News" isActive={type === "saved_news"} href="/saved" />
    </div>
  </div>
);

ProfileMenuMobile.propTypes = {
  type: string
};

export default ProfileMenuMobile;
